import { useMintLessonEditorPlusV1Lib, useMintLessonVisorPlusV1Lib } from '@oneclick/react-mint-editor';
import * as Sentry from '@sentry/react';
import { DEFAULT_LANG } from 'app/config/config';
import { getLemonadeTranslates } from 'app/utils/lemonade-translates';
import { isLocalhost } from 'core';
import * as coreEntities from 'core/store/index';
import { getRoleUserString } from 'core/utils/user';
import { CLIENT } from 'core/variables/constant';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/pt';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const InitsContainer = () => {
  const currentUser = useSelector((state) => coreEntities.auth.selectors.getUser(state));
  const tenant = useSelector((state) => coreEntities.organization.selectors.getTenant(state));
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  const { api: apiEditor } = useMintLessonEditorPlusV1Lib();
  const { api: apiVisor } = useMintLessonVisorPlusV1Lib();

  useEffect(() => {
    const supportedLocales = ['pt', 'en', 'es'];
    const locale = supportedLocales.includes(language) ? language : 'es';
    moment.locale(locale);
  }, [language]);

  useEffect(() => {
    if (tenant && !isLocalhost()) {
      Sentry.init({
        dsn: 'https://c583e7250991f783148988b55836f209@o4505759437029376.ingest.us.sentry.io/4506257572626432',
        environment: tenant?.name,
        integrations: [
          Sentry.replayIntegration(),
          // Sentry.replayCanvasIntegration()
          Sentry.thirdPartyErrorFilterIntegration({
            // Specify the application keys that you specified in the Sentry bundler plugin
            filterKeys: ['tangerine-frontoffice'],

            // Defines how to handle errors that contain third party stack frames.
            // Possible values are:
            // - 'drop-error-if-contains-third-party-frames'
            // - 'drop-error-if-exclusively-contains-third-party-frames'
            // - 'apply-tag-if-contains-third-party-frames'
            // - 'apply-tag-if-exclusively-contains-third-party-frames'
            behaviour: 'drop-error-if-contains-third-party-frames',
          }),
        ],

        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event, hint) {
          const errorMessage = hint?.originalException?.message;

          // Comprueba si el mensaje de error es el que quieres ignorar
          const IGNORED_ERROR_PATTERNS = [
            'cannot be parsed as a URL',
            'Failed to fetch',
            '$(iframe).attr',
            'Network Error',   // Axios XHR network failure (capital N and E)
            'network error',   // Firefox lowercase variant
            'NetworkError',    // DOMException variant
          ];
          if (IGNORED_ERROR_PATTERNS.some((p) => errorMessage?.includes(p))) {
            // No enviar el evento a Sentry
            return null;
          }

          return event;
        },
      });
    }
  }, [tenant]);

  useEffect(() => {
    if (currentUser && !isLocalhost()) {
      Sentry.setUser({
        id: currentUser.guid,
        username: currentUser.username,
        name: `${currentUser.name} ${currentUser.lastname}`,
        role: currentUser.role_name,
      });
    } else if (!currentUser && !isLocalhost()) {
      // Clear user data when user logs out
      Sentry.setUser(null);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser && tenant) {
      initStonly();
    }
  }, [currentUser, tenant]);

  useEffect(() => {
    getLemonadeTranslates(apiEditor, apiVisor);
  }, []);

  function initStonly() {
    if (window.StonlyWidget !== undefined) {
      window.StonlyWidget('enableDebug');
      if (currentUser?.guid) {
        let data = {
          lang: currentUser.lang_id || DEFAULT_LANG,
          role: getRoleUserString(currentUser),
          'user-segment': currentUser.is_demo === 1 ? 'demo' : '',
        };
        if (tenant?.guid === CLIENT.GOTITBYME) {
          // Para GOTITBYME, cambiamos los nombres de los campos
          data = {
            lang: currentUser.lang_id || DEFAULT_LANG,
            'role-gotit': getRoleUserString(currentUser),
            'user-segment-gotit': currentUser.is_demo === 1 ? 'demo' : '',
          };
        }
        window.StonlyWidget('identify', currentUser.guid, data);
      } else {
        window.StonlyWidget('identify', null, { 'user-segment': '' });
      }
    }
  }

  return <></>;
};

export default InitsContainer;
